import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Pagination } from '@/components/Pagination';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { useI18n } from '@/contexts/I18nContext';
import api from '@/lib/api';

const PAGE_SIZE = 20;

const actionBadge = {
  submitted: { label: 'status.submitted', className: 'bg-blue-100 text-blue-800' },
  resubmitted: { label: 'status.submitted', className: 'bg-blue-100 text-blue-800' },
  approved: { label: 'status.approved', className: 'bg-green-100 text-green-800' },
  rejected: { label: 'status.rejected', className: 'bg-red-100 text-red-800' },
  correction_requested: { label: 'status.correction_needed', className: 'bg-orange-100 text-orange-800' },
};

export default function AuditLogs() {
  const { t } = useI18n();
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    api.get('/audit-logs').then(r => setLogs(r.data)).catch(() => {});
  }, []);

  const paginated = logs.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="space-y-6 animate-fade-in" data-testid="audit-logs-page">
      <h1 className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>{t('admin.audit')}</h1>

      <Card className="border">
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Date</TableHead>
                  <TableHead>Action</TableHead>
                  <TableHead>{t('dash.applications')}</TableHead>
                  <TableHead>Par</TableHead>
                  <TableHead>{t('emb.notes')}</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {paginated.map(log => {
                  const ab = actionBadge[log.action] || { label: log.action, className: 'bg-gray-100 text-gray-800' };
                  return (
                    <TableRow key={log.log_id}>
                      <TableCell className="text-sm text-muted-foreground whitespace-nowrap">
                        {log.created_at ? new Date(log.created_at).toLocaleString('fr-FR') : '-'}
                      </TableCell>
                      <TableCell><Badge className={ab.className}>{t(ab.label)}</Badge></TableCell>
                      <TableCell className="text-sm">{log.applicant_name || '-'}</TableCell>
                      <TableCell className="text-sm">{log.performer_name || '-'}</TableCell>
                      <TableCell className="text-sm text-muted-foreground max-w-xs truncate">{log.notes || '-'}</TableCell>
                    </TableRow>
                  );
                })}
                {paginated.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} className="text-center py-8 text-muted-foreground">Aucun log</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <div className="px-4 pb-4">
            <Pagination total={logs.length} pageSize={PAGE_SIZE} currentPage={page} onPageChange={setPage} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
